import { ApiPaginatedResponse, ApiResponse, http } from '@config/api';
import { Nullable } from '@utils/util.types';

export interface CreateFarmPayload {
	crop_id: string;
	crop_area: string;
	crop_unit: string;
	crop_variety: Nullable<string[]>;
}

export interface UpdateFarmPayload {
	crop_id: string;
	crop_area: string;
	crop_unit: string;
	crop_variety: Nullable<string[]>;
	irrigation_system: boolean;
	irrigation_system_id: string;
	planted: boolean;
	weather_station: boolean;
	irrigation_water: boolean;
	sensors: boolean;
	management_soft: boolean;
	greenhouse: boolean;
	farm_files: Nullable<any>;
	is_proceed: boolean;
}

export async function createFarm(payload: CreateFarmPayload) {
	const response = await http.post<ApiResponse<{ data: { farmID: string } }>>('farms', '', payload);

	return response.data.data;
}

export async function updateFarm(payload: Partial<UpdateFarmPayload>, farmId: string) {
	const response = await http.put<ApiResponse<any>>(`farms`, `${farmId}`, payload);

	return response.data;
}

export async function fetchFarms(pageNumber = 1, pageSize = 10) {
	const response = await http.get<ApiResponse<ApiPaginatedResponse<any>>>(`farms`, '', {
		'page-number': pageNumber,
		'page-size': pageSize,
	});

	return response.data.data;
}

export async function deleteFarm(farmId: string) {
	const response = await http.delete<ApiResponse<any>>(`farms`, `${farmId}`);

	return response.data;
}

export async function fetchSingleFarm(farmId: string) {
	if (farmId) {
		const response = await http.get<ApiResponse<any>>(`farms`, `${farmId}/`);

		return response.data.data;
	}
}

export async function deleteFarmFile(fileId: string) {
	const response = await http.delete<ApiResponse<any>>(
		'farms',
		`delete-farm-file/?param=${fileId}`
	);

	return response.data;
}
